package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.gstechnovos.jexonplastech.models.Testimonial
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.sections.RatingBar
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun TestimonialCard(
    modifier: Modifier = Modifier, testimonial: Testimonial
) {

    val breakpoint = LocalBreakpoint.current

    Row(modifier = modifier.maxWidth(500.px)) {

        Image(
            src = testimonial.image,
            description = "avatar image",
            modifier = Modifier.margin(right = 10.px).maxWidth(if (breakpoint > Breakpoint.MD) 160.px else 80.px)
                .borderRadius(
                    topLeft = 60.px, topRight = 60.px, bottomRight = 0.px, bottomLeft = 60.px
                )
        )

        Column {
            Row(
                modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)
            ) {
                Column {
                    P(
                        attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY)
                            .fontSize(18.px).fontWeight(
                                FontWeight.Bold
                            ).color(Theme.Secondary.rgb).toAttrs()
                    ) {
                        Text(
                            testimonial.fullName
                        )
                    }

                    P(
                        attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY)
                            .fontSize(12.px).fontWeight(
                                FontWeight.Normal
                            ).color(Theme.Secondary.rgb).toAttrs()
                    ) {
                        Text(testimonial.profession)
                    }

                    RatingBar(modifier = Modifier.margin(top = 5.px))
                }
            }

            P(
                attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px).fontFamily(Constants.FONT_FAMILY)
                    .fontSize(12.px).fontWeight(
                        FontWeight.Normal
                    ).color(Theme.Secondary.rgb).toAttrs()
            ) {
                Text(
                    testimonial.review
                )
            }
        }
    }
}